import {createMainMap} from './box-building-stats/create-main-map';
import {getSensorData} from "./box-building-stats/get-sensor-data";

if (document.getElementById('map--building') != null) {
    google.maps.event.addDomListener(window, 'load', mapBuilding);
}

let selectedControlPointIdElement = document.getElementById('selectedControlPointId');
let chartContainer = document.getElementById('c-box-building-stats__chart--1');
if (selectedControlPointIdElement != null && chartContainer) {
    let selectedControlPointId = selectedControlPointIdElement.value;
    let label = document.getElementById('selectedControlPointLabel').value;
    getSensorData(selectedControlPointId, 'WEEK', 'c-box-building-stats__chart--1', 'LineChart', label);
}

/*
* Init Google map with markers.
* */
function mapBuilding() {
    let buildingId = document.querySelector('#building_id');
    buildingId = (buildingId) ? buildingId.value : null;

    if (buildingId) {
        let apiUrl = `/api/building/${buildingId}/control-point`;

        fetch(apiUrl)
            .then(response => {
                return response.json();
            })
            .then(data => {
                const mapZoom = data.building.zoom || 18;
                const mapLat = data.building.geoCoordinates.lat;
                const mapLng = data.building.geoCoordinates.lng;
                const markersJson = data.controlPoints;
                const markersStatesJson = data.controlPoints;
                const mapTypeId = data.building.mapTypeId || "terrain";

                /*
                * Run map init function.
                * */
                createMainMap(
                    mapZoom,
                    mapLat,
                    mapLng,
                    markersJson,
                    markersStatesJson,
                    mapTypeId
                );

            })
            .catch(err => {
                console.error('mapBuilding()', err);
            })
    }
}
